import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from './../images/circle-info-regular-full.svg'

function RecordRecency ({ recordRecencyFilter, setRecordRecencyFilter }) {
  const today = new Date()
  const maxDate = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`

  const handleDateAddedChange = e => {
    setRecordRecencyFilter({
      ...recordRecencyFilter,
      dateAdded: e.target.value
    })
  }

  const handleDateUpdatedChange = e => {
    setRecordRecencyFilter({
      ...recordRecencyFilter,
      dateUpdated: e.target.value
    })
  }

  return (
    <div className={styles.RecordRecencyContainer}>
      <div className={styles.titleWithIcon}>
        <h1 className={styles.RecordRecencyTitle}>Record recency</h1>
      </div>

      <div className={styles.FlexContainer}>
        {/* Date added */}
        <div className={styles.FlexColumn}>
          <div className={styles.labelWithIcon}>
            <span className={styles.RecordRecencyLabel}>Date added</span>
            <Tooltip
              title='Filter to properties first added on or after the selected date.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 400,
                      fontSize: '13px',
                      padding: '10px 14px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Date added help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>
          <input
            className={styles.RecordRecencyInput}
            type='date'
            name='dateAdded'
            max={maxDate}
            value={recordRecencyFilter.dateAdded}
            onChange={handleDateAddedChange}
            required
          />
        </div>

        {/* Date updated */}
        <div className={styles.FlexColumn}>
          <div className={styles.labelWithIcon}>
            <span className={styles.RecordRecencyLabel}>Date updated</span>
            <Tooltip
              title='Filter to properties last updated on or after the selected date.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Date updated help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>
          <input
            className={styles.RecordRecencyInput}
            type='date'
            name='dateUpdated'
            max={maxDate}
            value={recordRecencyFilter.dateUpdated}
            onChange={handleDateUpdatedChange}
            required
          />
        </div>
      </div>
    </div>
  )
}

export default RecordRecency
